// extracted by mini-css-extract-plugin
var _1 = "FswNu";
var _2 = "dNnsW";
export { _1 as "banner", _2 as "frame" }
